export default {
    namespaced: true,

    state: {
        form_is_valid: true,
        checking: false,

        current_step: 1,
        editable_steps: false,

        quote_id: null,

        current_tab: null,

        client_rating: 2,
        client_search_results: [],

        education_options: [],
        gender_options: [],
        smoking_options: [],

        checking_rating: false,

        resources_loaded: false,
    },

    getters: {
        getFormIsValid(state) {
            return state.form_is_valid;
        },
        getChecking(state) {
            return state.checking;
        },
        getCurrentStep(state) {
            return state.current_step;
        },
        getQuoteId(state) {
            return state.quote_id;
        },

        getCurrentTab(state) {
            return state.current_tab;
        },
        getEditableSteps(state) {
            return state.editable_steps;
        },

        getClientRating(state) {
            return state.client_rating;
        },
        getClientSearchResults(state) {
            return state.client_search_results;
        },

        getEducationOptions(state) {
            return state.education_options;
        },
        getGenderOptions(state) {
            return state.gender_options;
        },
        getSmokingOptions(state) {
            return state.smoking_options;
        },

        getCheckingRating(state) {
            return state.checking_rating;
        },
        getResourcesLoaded(state) {
            return state.resources_loaded;
        }
    },

    actions: {
        getAll(context) {
            return new Promise((resolve, reject) => {
                if (context.getters.getResourcesLoaded) {
                    resolve();
                    return false;
                }

                window.axios.post('/calculators/generalResources')
                    .then((response) => {
                        context.commit('setEducationOptions', response.data.education);
                        context.commit('setGenderOptions', response.data.gender);
                        context.commit('setSmokingOptions', response.data.smoking);

                        context.commit('setResourcesLoaded', true);

                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            });
        },
        resetAll(context) {
            context.commit('setFormIsValid', true);
            context.commit('setChecking', false);
            context.commit('setCurrentStep', 1);
            context.commit('setCurrentTab', null);
            context.commit('setEditableSteps', false);
        },

        getClientRating(context, client) {
            context.commit('setChecking', true);

            return new Promise((resolve, reject) => {
                if (context.getters.getCheckingRating) {
                    resolve();
                    return false;
                }

                context.commit('setCheckingRating', true);

                window.axios.post('/calculators/clientRating', {
                    client: client,
                })
                    .then((response) => {
                        context.commit('setClientRating', response.data.rating);
                        context.commit('setChecking', false);
                        context.commit('setCheckingRating', false);

                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        context.commit('setChecking', false);
                        context.commit('setCheckingRating', false);

                        reject(error);
                    });
            });
        },

        searchClients(context, query) {
            return new Promise((resolve, reject) => {
                window.axios.post('/calculators/clientSearch', {
                    query: query,
                })
                    .then((response) => {
                        context.commit('setClientSearchResults', response.data.clients);
                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            });
        },

        updateServerCurrentStep(context) {
            window.axios.post('/calculators/quotationUpdateStep', {
                quote_id: context.getters.getQuoteId,
                current_step: context.getters.getCurrentStep,
            });
        },

        saveQuote(context, data) {
            context.commit('setChecking', true);

            window.axios.post('/calculators/quotationSave', {
                quote_id: context.getters.getQuoteId,
                quote_name: data.quote_name,
                client_name: data.client_name,
            })
                .then((response) => {
                    context.commit('setChecking', false);

                })
                .catch((error) => {
                    console.error(error);
                    context.commit('setChecking', false);
                });
        }
    },

    mutations: {
        setFormIsValid(state, boolean) {
            state.form_is_valid = boolean;
        },
        setChecking(state, boolean) {
            state.checking = boolean;
        },
        setCurrentStep(state, value) {
            state.current_step = value;
        },
        setQuoteId(state, id) {
            state.quote_id = id;
        },
        setCurrentTab(state, value) {
            state.current_tab = value;
        },
        setEditableSteps(state, boolean) {
            state.editable_steps = boolean;
        },

        setClientRating(state, rating) {
            state.client_rating = rating;
        },
        setClientSearchResults(state, results) {
            state.client_search_results = results;
        },

        setEducationOptions(state, options) {
            state.education_options = options;
        },
        setGenderOptions(state, options) {
            state.gender_options = options;
        },
        setSmokingOptions(state, options) {
            state.smoking_options = options;
        },

        setCheckingRating(state, boolean) {
            state.checking_rating = boolean;
        },

        setResourcesLoaded(state, boolean) {
            state.resources_loaded = boolean;
        }
    }
}
